import { useMemo } from 'react';

import { Breakpoint } from '@/hooks/use-breakpoints';

import { Card, CardProps } from '@/components/card';

import Carousel, {
  CarouselItem,
  CarouselPerPage,
  CarouselVariant,
} from '@/features/carousel';

export type CardsCarouselProps = {
  cards: CardProps[];
  desktopCardsPerPage: CarouselPerPage;
  mobileCardsPerPage: CarouselPerPage;
};

export default function CardsCarousel({
  cards,
  mobileCardsPerPage,
  desktopCardsPerPage,
}: CardsCarouselProps) {
  const items = useMemo((): CarouselItem[] => {
    return cards.map((card, index) => ({
      id: index.toString(),
      component: (
        <Card
          {...card}
          image={
            card.image && {
              ...card.image,
              draggable: false,
              imgClassName: 'w-full',
            }
          }
        />
      ),
    }));
  }, [cards]);

  return (
    <Carousel
      variant={CarouselVariant.PAGINATED}
      items={items}
      showPagination
      perPage={{
        [Breakpoint.sm]: mobileCardsPerPage,
        [Breakpoint.md]: desktopCardsPerPage,
      }}
    />
  );
}
